import {ContentChildren, Directive, HostListener, OnDestroy, QueryList} from '@angular/core';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {TableControlComponent} from 'frontier';
import {Subject} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Directive({
  selector: '[libTabActivated]',
  standalone: true,
})
export class TabActivatedDirective implements OnDestroy {
  // Static registry of all directive instances
  private static instances = new Set<TabActivatedDirective>();

  @ContentChildren(TableControlComponent, {descendants: true})
  components!: QueryList<TableControlComponent>;

  private tabChanged$: Subject<MatTabChangeEvent> = new Subject<MatTabChangeEvent>();
  private readonly tables: Set<TableControlComponent> = new Set<TableControlComponent>();

  constructor() {
    // Register this instance
    TabActivatedDirective.instances.add(this);

    // Subscribe to this instance's tab change events and notify all instances
    this.tabChanged$
      .pipe(takeUntilDestroyed())
      .subscribe((): void => {
        TabActivatedDirective.instances.forEach((dir: TabActivatedDirective): void => {
          dir.tables.forEach((table: TableControlComponent): void => table.onTabActivated());
        });
      });
  }

  /**
   * Angular lifecycle hook to clean up on destroy
   */
  ngOnDestroy(): void {
    // Unregister this instance
    TabActivatedDirective.instances.delete(this);
  }

  /**
   * Called by TableControlComponents when they initialize
   */
  registerTable(table: TableControlComponent): void {
    this.tables.add(table);
  }

  /**
   * Called by TableControlComponents when they destroy
   */
  unregisterTable(table: TableControlComponent): void {
    this.tables.delete(table);
  }

  @HostListener('selectedTabChange', ['$event'])
  onTabChange(event: MatTabChangeEvent): void {
    this.tabChanged$.next(event);
  }
}
